import styled from 'styled-components';

import Button from '../../components/Button';

const PageContainer = styled.div`
`;

interface ColumnContainerProps {
  stack: boolean;
}

const ColumnContainer = styled.div<ColumnContainerProps>`
  column-count: ${({ stack }) => (stack ? 1 : 2)};
  column-gap: ${({ theme }) => theme.spacing(4)};
`;

const VideoColumn = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing(2)};
`;

const DetailsColumn = styled.div`
  display: inline-block;
  width: 100%;
  flex-direction: column;
`;

const ActionButton = styled(Button)`
  && {
    width: fit-content;
    margin-right: ${({ theme }) => theme.spacing(2)};
  }
`;

export { PageContainer,
  ActionButton,
  ColumnContainer,
  VideoColumn,
  DetailsColumn };
